class Profile {
  public firstName: string = null;
  public lastName: string = null;
  public gender: string = null;
  public address: string = null;
  public addressComplement: string = null;
  public postalCode: string = null;
  public city: string = null;
  public position: string = null;
  public department: string = null;
  public company: string = null;
  public phone: string = null;

  public static fromPayload(pl: Partial<Profile>) {
    !pl && (pl = {});
    const o = new Profile()
    Object.assign(o, pl);

    return o;
  }


}

export { Profile }
